import { createAction, props } from '@ngrx/store';
import { BypassChain, BypassListResponse, BypassRule } from '../bypass-list.model';

export const setBypassList = createAction(
  '[Bypass List] set',
  props<{ bypassList: BypassListResponse }>()
);

export const addBypassRule = createAction(
  '[Bypass List] add',
  props<{ chain: BypassChain; bypassRule: BypassRule }>()
);

export const updateBypassRule = createAction(
  '[Bypass List] update',
  props<{ chain: BypassChain; bypassRule: BypassRule }>()
);

export const reorderBypassRules = createAction(
  '[Bypass List] reorder',
  props<{ chain: BypassChain; rules: BypassRule[] }>()
);

export const deleteBypassRules = createAction(
  '[Bypass List] delete',
  props<{ chain: BypassChain; ids: string[] }>()
);

export const setBypassListSaved = createAction('[Bypass List] set saved');

export const clearBypassList = createAction('[Bypass List] clear');
